import { SERVICES_FETCH } from "../action-types/services-types";

const initialState = {
  entities: [],
  entity: {},
  entityLoaded: false,
  loading: false,
};
const prepAttribute = data => {
  const attributesParent = {
    digitalKioskType: 'digitalKiosk',
    numberOfKiosk: 'digitalKiosk',
    hasBurgersForBreakfast: 'servesBreakfast',
  };
  return data.map(attribute => {
    attribute.parent = attributesParent[attribute.code];
    return attribute;
  });
};
export default function (state = initialState, action) {
  switch (action.type) {
    case SERVICES_FETCH.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SERVICES_FETCH.REJECTED:
      return {
        ...state,
        loading: false,
      };
    case SERVICES_FETCH.SUCCESS:
      return {
        ...state,
        entities: prepAttribute([...action.payload.data]),
        loading: false,
      };
    default:
      return state;
  }
}
